import { formatDate } from '@artosera/shared';
import { ShieldAlert } from 'lucide-react';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';
import type { SessionUtilisateur } from '../../api/types.js';
import { useLangue } from '../../composants/useLangue.js';
import styles from '../racine/BandeauHorsLigne.module.css';

/**
 * Rappel de la grâce : la double authentification est exigée de ce compte,
 * qui ne l'a pas encore activée. Non bloquant ; masqué sur Réglages ›
 * Sécurité, où l'on s'enrôle, et parti dès que la session relue ne l'exige
 * plus. Une session confinée n'arrive jamais ici (`routes/loaders.ts`).
 */
export function BandeauDoubleAuthentification({
  session,
  galerieSlug,
}: {
  session: SessionUtilisateur;
  galerieSlug: string;
}): JSX.Element | null {
  const { t } = useTranslation('regie');
  const langue = useLangue();
  const { pathname } = useLocation();
  const securite = `/${galerieSlug}/reglages/securite`;
  if (!session.enrolementMfaRequis || session.enrolementMfaSeulement || pathname === securite)
    return null;
  const limite = session.compte.graceMfaJusquau ? new Date(session.compte.graceMfaJusquau) : null;
  return (
    <div className={styles.bandeau} role="status">
      <span className={styles.icone} aria-hidden="true">
        <ShieldAlert size={16} strokeWidth={1.75} />
      </span>
      <span className={styles.texte}>
        {limite && !Number.isNaN(limite.getTime())
          ? t('coquille.doubleAuthentification.avantLe', { date: formatDate(limite, langue) })
          : t('coquille.doubleAuthentification.sansDate')}{' '}
        <Link to={securite}>{t('coquille.doubleAuthentification.lien')}</Link>
      </span>
    </div>
  );
}
